import React from 'react'
import { Section } from '@shared/components/section'
import cx from 'classnames'

import styles from './style.module.scss'

const steps = [
	['Оставьте заявку онлайн за пару минут', styles.stepOne],
	['Сразу же узнайте предварительное решение', styles.stepTwo],
	['Получите деньги там, где вам удобно', styles.stepTree],
]

export const View = () => (
	<Section className={styles.wrapper}>
		<div className={styles.stepsWrapper}>
			{steps.map(([label, customClassName], i) => (
				<div key={label} className={styles.step}>
					<div className={cx(styles.stepNumber, customClassName)}>{i + 1}</div>
					<h4 className={styles.stepText}>{label}</h4>
				</div>
			))}
		</div>
	</Section>
)
